<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            ref="grid"
            :beforeSetupGrid="beforeSetupGrid"
            :expandedOptions="{
                enabled: true,
                template: 'camp-call-details',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Call Logs",

        url: "",
        actions: [],
        fromDate: "",
        toDate: "",

        columns: [
            {
                label: "Start Time",
                field: "startTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "End Time",
                field: "endTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Duration",
                field: "duration",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Price",
                field: "price",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Call SID",
                field: "callSid",
                template: "link-action-cell-template",
                format: "",
                filterType: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Carrier",
                field: "carrier",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find((c) => c.field == "callSid").linkAction = (call) => {
            const url =
                call.carrier == "Twilio"
                    ? "https://www.twilio.com/console/voice/calls/logs/" +
                      call.callSid
                    : "https://utaw.signalwire.com/laml-calls/" + call.callSid;

            window.open(url);
        };

        this.actions.push({
            text: "Import Calls",
            name: "Import Calls",
            action: this.importCalls,
            showOnSelection: false,
        });
    },
    methods: {
        async beforeSetupGrid() {
            this.fromDate = toISOLocal(
                new Date(moment().subtract(1, "days"))
            ).substr(0, 10);
            this.toDate = toISOLocal(new Date(moment().add(1, "days"))).substr(
                0,
                10
            );

            this.actions.push({
                text: "From Date",
                type: "datepicker",
                value: this.fromDate,
                onChanged: this.onFromDateChanged,
                align: "left",
            });

            this.actions.push({
                text: "To Date",
                type: "datepicker",
                value: this.toDate,
                onChanged: this.onToDateChanged,
                align: "left",
            });

            this.url =
                "signalwireCalls?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;
        },
        onFromDateChanged(value) {
            this.fromDate = value;

            this.url =
                "signalwireCalls?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onToDateChanged(value) {
            this.toDate = value;

            this.url =
                "signalwireCalls?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async importCalls() {
            await this.$http.post(
                "https://api-3t6ck5zrrq-ue.a.run.app/CallLogs/ImportCalls"
            );

            this.$refs.grid.reloadGrid();
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.action-tile .v-list__tile {
    height: 65px;
}
</style>
